import React from "react";

const Unauthorized = () => <h1>Unauthorized Access</h1>;

export default Unauthorized;
